declare let VERSION: string;

const VersionSeparator = '_version_';
export const useLocalStorage = () => {
    return {
        getLocalStorage: (saveID: string) => {
            clearMismatchVersion(saveID);
            return localStorage.getItem(`${saveID}${VersionSeparator}${VERSION}`);
        },
        getStoredObject<T>(saveID: string) {
            clearMismatchVersion(saveID);
            return JSON.parse(localStorage.getItem(`${saveID}${VersionSeparator}${VERSION}`) || '{}') as T;
        },
        storeObject<T>(saveID: string, val: T) {
            clearMismatchVersion(saveID);
            localStorage.setItem(`${saveID}${VersionSeparator}${VERSION}`, JSON.stringify(val));
        },
        setLocalStorage: (saveID: string, saveValue: string) => {
            clearMismatchVersion(saveID);
            localStorage.setItem(`${saveID}${VersionSeparator}${VERSION}`, saveValue);
        },
        removeLocalStorage: (saveID: string) => {
            clearMismatchVersion(saveID);
            localStorage.removeItem(`${saveID}${VersionSeparator}${VERSION}`);
        },
    };
};

const getSaveID = (saveIDWithVersion: string): { saveID: string; version: string } => {
    const strings = saveIDWithVersion.split(VersionSeparator).filter((i) => i.length);
    if (strings.length === 2) {
        return { saveID: strings[0], version: strings[1] };
    } else if (strings.length === 1) {
        return { saveID: strings[0], version: '' };
    }
    return { saveID: '', version: '' };
};

const clearMismatchVersion = (saveID: string): void => {
    Object.keys(localStorage).forEach((key: string) => {
        const saveIDInKey = getSaveID(key);
        if (saveIDInKey.saveID === saveID && saveIDInKey.version !== VERSION) {
            localStorage.removeItem(key);
        }
    });
};
